import React from 'react'

import ImageWithText from '@/components/flows/WalkthroughFlow/components/ImageWithText'
import screenshotUrl from '@/components/flows/WalkthroughFlow/steps/4_CompassScreen/screenshot.png'

const CompassScreen: React.FC = () => (
  <ImageWithText
    imageUrl={screenshotUrl}
    text={
      <p className="mb-4">
        Compass is RQ's client diagnostic tool. It helps uncover gaps in your
        clients’ financial health and spot referral opportunities— through a
        simple, structured process.
      </p>
    }
  />
)

export default CompassScreen
